<div class="planner-header-sticky" #headerStickyRef>
    <div class="month-Year-Main">

        <div class="d-flex align-items-center w-100">
            <div class="d-flex" *ngIf="!isView">
                <div class="dealerName-wt mr-2"><span translate>lblDealersName</span>:</div>
                <div>{{dealerName}}</div>
            </div>
            <div class="d-flex align-items-center m-auto">
                <button class="btn btn-outline-primary" (click)="onSchedulerPreviousClick()" aria-label="Center Align">
                    <em class="fas fa-arrow-left fa-lg"></em>
                </button>
                <div class="month-Year-child card-header text-center" *ngIf="schedularHeaderInfo">
                  <input class="card-header text-center datePicker width100force" appAfDatepicker [isShowWeek]="true" [startDate]="'1900/01/01'" [format]="'F-Y'"
                  readonly [dateTime]="false" [ngModelOptions]="{standalone: true}" [ngModel]="showMonth" (OnSelect)="onChangeDate($event)">
                </div>
                <button class="btn btn-outline-primary" aria-label="Center Align" (click)="onSchedulerNextClick()">
                    <em class="fas fa-arrow-right fa-lg"></em>
                </button>
            </div>
            <div *ngIf="isScheduleSummary" class="day-available-hours d-flex align-items-center mr-2">
                <div class="todays-available-text"><span translate>lblPlannedHours/TotalHours</span></div>
            </div>
            <div *ngIf="!isScheduleSummary" class="day-available-hours d-flex align-items-center">
                <div class="todays-available-text"><em class="fas fa-clock fa-lg mr-2"></em><span translate>lblRemainingHours</span> :</div>
                <div class="todays-available">{{hour}} <span translate>lblHours</span></div>
            </div>
        </div>


    </div>

    <div [ngClass]="{'topstatic':isScheduleSummary }">


        <div [ngClass]="{'d-flex schedule-summary':isScheduleSummary }" class="">
            <div *ngIf="isScheduleSummary" class="dealer-width col-auto"> <label style="align-self: center;">Dealer</label> </div>
            <div class="planning-dates p-0">

                <!-- For Main Planner Start-->
                <ul [ngClass]="{'planning-month-scheduleSummary': isScheduleSummary }" class="planning-month d-flex flex-nowrap" id="monthScrollDiv">
                    <ng-container *ngIf="schedularHeaderInfo?.infos">
                        <li *ngFor="let item of schedularHeaderInfo.infos;let i=index" [ngClass]="{'monthScrollDiv':i==0}" [attr.id]="item.isCurrent?'scrollToMe':null" [ngClass]="{'selected':item.isCurrent}"
                            [class.booked-low]="item.rationClass==='booked-low'"
                            [class.booked-medium]="item.rationClass==='booked-medium'"
                            [class.booked-high]="item.rationClass==='booked-high'">
                            <a [ngStyle]="{'cursor': isScheduleSummary ? 'initial' : 'cursor'}" (click)="!isScheduleSummary && onDayClick(item)">
                                <ng-container>
                                    <div class="day" [ngClass]="{'state-3': item.isHoliday || item.isCurrent}">
                                        {{item.dayName | translate}}</div>
                                </ng-container>



                                <div class="date" [ngClass]="{'state-selected':item.isCurrent , 'state-3':item.isHoliday}">
                                    {{item.cdate}}</div>
                                <ng-container *ngIf="!isScheduleSummary && item.plannedHours!==undefined && item.availableHours!==undefined  && item.plannedHours!==null && item.availableHours!==null; else load_header_else ">
                                    <div class="hours" [ngClass]="{'state-selected':item.isCurrent , 'state-3':item.isHoliday}">

                                        {{item.plannedHours | number:'1.0-0'}} / {{item.availableHours | number:'1.0-0'}}
                                    </div>
                                </ng-container>
                                <ng-template load_header_else>
                                    0
                                </ng-template>


                            </a>

                        </li>
                    </ng-container>
                </ul>
                <!-- For Main Planner END-->

            </div>
        </div>


        <div *ngIf="isScheduleSummary">

            <ng-container *ngFor="let item of dealerdata">
                <div class="d-flex odd-even">
                    <div class="testings initialpositionoftable horz-date-day-scheduleSummary col-auto dealer-width btmborder-light">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex flex-column justify-content-between " tooltipClass="my-tooltip" container="body" *ngIf="isReadOnly">
                                <label [ngClass]="mechanic-not-available" style="align-self: center;">
                            {{item.dealerName}}
                        </label>
                            </div>
                        </div>
                    </div>
                    <div class="p-0 d-flex justify-content-around btmborder-w align-items-center flex-grow-1">
                        <div *ngFor="let m of monthDays; let i = index" class="w-100">
                            <ng-container>
                                <div class="center-align-cells" [ngClass]="{'day-cell':item.open[i], 'day-cell-holiday': !item.open[i], 'booked-75':item.bookedPercentage[i] >= 75}">
                                     <div>
                                        {{item.plannedHours[i] | number:'1.0-0'}} / {{item.availableHours[i] | number:'1.0-0'}}
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                </div>
            </ng-container>

        </div>
    </div>
</div>














<div *ngIf="!isScheduleSummary && genericSchedulerList != null" style="margin-bottom: -35px;">

    <div class="week-horz-btns week-horz-btns-height fix-day-info left-content-header" [ngClass]="{'time-horz-box-gray': isGrayHeaderBorder}">
        <div class="date-header flex-center space-between flex-grow w-100">
            <div class="planner-left-header planner-left-header-page">
                <span class="day-Percent d-flex align-items-center" id="dayTitleDate">
                <span class="mr-auto bold">
                    {{selectedDate | date : 'EEEE, d MMM' : 'undefined' : lang }}
                </span>

                <span class="d-flex align-items-center form-check mr-2 ms-auto" *ngIf="!isView">
                    <input type="checkbox" id="showAll" class="form-check-input mt-0" [(ngModel)]="isShowAll"
                        (change)="OnClickShowAll()" />
                    <label class="form-check-label text-dark bold" for="showAll" translate>lblShowAll</label>
                </span>

                </span>
            </div>
        </div>
    </div>
    <div class="week-horz-left day-horz-left left-scroller" #leftScroller (scroll)="onMechanicListScroll($event)">
        <ng-container *ngIf="!isScheduleSummary && genericSchedulerList && genericSchedulerList.length > 0">
            <ng-container *ngFor="let item of genericSchedulerList">
                <div class="testings horz-date horz-date-day initialpositionoftable">
                    <div class="px-1 ">
                        <div class="px-1" *ngIf="isReadOnly">
                            <div style="display: flex;">
                                <label class="text-truncate" tooltipClass="my-tooltip" [ngbTooltip]="mechanicTooltipContent" container="body" [ngClass]="{'mechanic-not-available': isViewAppointment || !item.isActive || item.isOnLeave}">
                                    {{item.pText}} 
                                </label>
                                <span>({{item.efficiency}}%)</span>
                                <ng-template #mechanicTooltipContent>
                                    <div class="d-flex flex-column">
                                        <div> <span translate>lblName</span>: {{item.pText}} </div>
                                        <div *ngIf="item.skillDescription"> <span translate>lblSkillDescription</span>: {{item.skillDescription}} </div>
                                    </div>
                                </ng-template>
                                <span  tooltipClass="my-tooltip" class="ml-auto" ngbTooltip="{{'lblCapacityPlanningIsOff' | translate}}" style="vertical-align: top;" *ngIf="!item.isCapacityPlanning">
                                    <i class="fa fa-user-times" aria-hidden="true"></i>
                                </span>
                                <div class="availablemechours ml-1 " style="font-size: 11px; margin-top: 2px;" [ngClass]="{'ml-auto' : item.isCapacityPlanning}">
                                    {{item?.bookedHour}}/{{item?.totalHour}}
                                </div>
                            </div>
                            

                        <div style="display: flex;margin-top: 5px;">
                            <span class="text-truncate compatancy-text" tooltipClass="my-tooltip"ngbTooltip="{{item.competence}} " container="body">{{item.competence}}</span>
                        </div>
                        </div>

                        <div class="px-1" *ngIf="!isReadOnly">
                            <div style="display: flex;">
                                <label class="text-truncate" tooltipClass="my-tooltip" [ngbTooltip]="mechanicTooltipContentReadonly"  container="body" href="javascript:void(0);"  [ngClass]="{'mechanic-not-available': isViewAppointment || !item.isActive || item.isOnLeave}">
                                    {{item.pText}}
                                </label>
                                <span>({{item.efficiency}}%)</span>
                                    <span tooltipClass="my-tooltip" class="ml-auto" ngbTooltip="{{'lblCapacityPlanningIsOff' | translate}}"  *ngIf="!item.isCapacityPlanning">
                                        <i class="fa fa-user-times" aria-hidden="true"></i>
                                    </span>
                                    <div class="availablemechours ml-1" style="font-size: 11px; margin-top: 2px;" [ngClass]="{'ml-auto' : item.isCapacityPlanning}">
                                        {{item?.bookedHour}}/{{item?.totalHour}}
                                    </div>  
                            </div>
                            <ng-template #mechanicTooltipContentReadonly>
                                <div class="d-flex flex-column">
                                    <div> <span translate>lblName</span>: {{item.pText}} </div>
                                    <div *ngIf="item.skillDescription"> <span translate>lblSkillDescription</span>: {{item.skillDescription}} </div>
                                </div>
                            </ng-template>
                            <div style="display: flex;">
                                <span class="text-truncate compatancy-text mt-2" tooltipClass="my-tooltip"ngbTooltip="{{item.competence}} " container="body">{{item.competence}}</span>
                            </div>
                            
                        </div>

                        <ng-template #tipContent>
                            <div class="p-2 row text-left max-w250">
                                <div class="col-md-12 title16">
                                    {{item.pText}} ({{ item.pId}} )
                                </div>
                                <div class="col-md-6" *ngIf="item.shiftTime !== null">
                                    <label translate>lblTooltipShiftTime</label>
                                </div>
                                <div class="col-md-6" *ngIf="item.shiftTime !== null">
                                    - {{ item.shiftTime}}
                                </div>

                                <div class="col-md-6" *ngIf="item.lunchTime !== null">
                                    <label translate>lblTooltipLunchTime</label>
                                </div>
                                <div class="col-md-6" *ngIf="item.lunchTime !== null">
                                    - {{item.lunchTime}}
                                </div>
                                <div class="col-md-6" *ngIf="item.skillDescription !== null">
                                    <label translate>lblTooltipCompetencies</label>
                                </div>
                                <div class="col-md-6" *ngIf="item.skillDescription !== null">
                                    - {{item.skillDescription}}
                                </div>
                            </div>
                        </ng-template>

                    
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="isScheduleSummary">
            <ng-container *ngFor="let item of distinctDealers">

                <div class="testings horz-date horz-date-day initialpositionoftable">
                    <div class="d-flex align-items-center justify-content-between  px-1 ">
                        <div class="d-flex flex-column justify-content-between px-1" tooltipClass="my-tooltip" container="body" *ngIf="isReadOnly">
                            <label [ngClass]="mechanic-not-available">
                            {{item}}
                        </label>
                        </div>
                    </div>

                </div>
            </ng-container>
        </ng-container>
        <div *ngIf="genericSchedulerList && genericSchedulerList.length > 0"></div>
    </div>
</div>
